import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "urlChoice",
    "fileChoice",
    "urlInput",
    "fileInput",
    "fileError",
    "removeFlag",
    "dropZone",
    "fileCard",
    "fileName",
    "fileBadge",
    "fileMeta",
    "changeButton",
  ];

  static values = {
    maxFileSize: Number,
    allowedExtensions: Array,
  };

  connect() {
    this.syncChoices();
  }

  selectKind() {
    this.syncChoices();
  }

  selectedKind() {
    const checked = this.element.querySelector(
      'input[name="member_portfolio[registration_kind]"]:checked',
    );
    return checked ? checked.value : null;
  }

  syncChoices() {
    const kind = this.selectedKind();

    this.urlChoiceTarget.classList.toggle("is-selected", kind === "url");
    this.fileChoiceTarget.classList.toggle("is-selected", kind === "file");

    this.urlInputTarget.disabled = kind !== "url";
    this.fileInputTarget.disabled = kind !== "file";

    this.syncFileArea();
  }

  syncFileArea() {
    const hasFile = !this.fileCardTarget.hidden;
    this.dropZoneTarget.hidden = hasFile;
    this.changeButtonTarget.hidden = !hasFile;
  }

  openFileDialog(event) {
    event.preventDefault();
    this.fileInputTarget.click();
  }

  selectFile() {
    const file = this.fileInputTarget.files[0];
    if (!file) {
      return;
    }

    if (!this.validateFile(file)) {
      this.fileInputTarget.value = "";
      return;
    }

    this.showFileError("");
    this.removeFlagTarget.value = "0";
    this.fileNameTarget.textContent = file.name;
    this.fileBadgeTarget.textContent = this.extensionOf(file.name).toUpperCase();
    this.fileMetaTarget.textContent = `${this.formatFileSize(file.size)} / 選択済み`;
    this.fileCardTarget.hidden = false;
    this.syncFileArea();
  }

  removeFile(event) {
    event.preventDefault();

    this.fileInputTarget.value = "";
    this.removeFlagTarget.value = "1";
    this.fileNameTarget.textContent = "";
    this.fileBadgeTarget.textContent = "";
    this.fileMetaTarget.textContent = "";
    this.fileCardTarget.hidden = true;
    this.showFileError("");
    this.syncFileArea();
  }

  handleDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dropZoneTarget.classList.add("is-drag-over");
  }

  handleDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.dropZoneTarget.contains(event.relatedTarget)) {
      this.dropZoneTarget.classList.remove("is-drag-over");
    }
  }

  handleDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dropZoneTarget.classList.remove("is-drag-over");

    const files = event.dataTransfer.files;
    if (files.length === 0) {
      return;
    }

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(files[0]);
    this.fileInputTarget.files = dataTransfer.files;
    this.selectFile();
  }

  validateFile(file) {
    if (file.size > this.maxFileSizeValue) {
      this.showFileError(
        "ファイルサイズが10MBを超えています。10MB以下のファイルをアップロードしてください。",
      );
      return false;
    }

    if (!this.allowedExtensionsValue.includes(this.extensionOf(file.name))) {
      this.showFileError(
        `${this.allowedExtensionsValue.join("、")} のいずれかの形式でアップロードしてください。`,
      );
      return false;
    }

    return true;
  }

  showFileError(message) {
    this.fileErrorTarget.textContent = message;
  }

  extensionOf(fileName) {
    const parts = fileName.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  }

  formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + sizes[i];
  }
}
